import porcelainSage from './porcelainSage';
import stoneRose from './stoneRose';
import type { ModeTokens } from '../tokens';

export type PresetKey = 'porcelain-sage' | 'stone-rose';

export const PRESETS: Record<PresetKey, ModeTokens> = {
  'porcelain-sage': porcelainSage,
  'stone-rose': stoneRose,
};

export const DEFAULT_PRESET: PresetKey = 'stone-rose';

export function resolvePreset(raw: string | undefined): PresetKey {
  if (raw === 'porcelain-sage' || raw === 'stone-rose') {
    return raw;
  }
  if (raw && raw !== '') {
    // eslint-disable-next-line no-console
    console.warn(
      `[theme] Unknown VITE_THEME_PRESET="${raw}". Falling back to "${DEFAULT_PRESET}".`
    );
  }
  return DEFAULT_PRESET;
}
